import Feature19 from './Feature19'
export default Feature19
